import { defaultMutationFn } from 'api';
import { useMutation } from 'react-query';

export function useResetPassword({
  passwordToken,
  newPassword,
}: {
  passwordToken: string | null;
  newPassword: string;
}) {
  return useMutation({
    mutationFn: () => {
      return defaultMutationFn('/authenticate/resetPassword', 'POST', {
        passwordToken,
        newPassword,
      });
    },
  });
}
